import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import AboutBekaali from './components/AboutBekaali';
import BusinessDivisions from './components/BusinessDivisions';
import IndustriesServed from './components/IndustriesServed';
import WhyChooseUs from './components/WhyChooseUs';
import GlobalSourcing from './components/GlobalSourcing';
import FeaturedProducts from './components/FeaturedProducts';
import Testimonials from './components/Testimonials';
import LatestNews from './components/LatestNews';
import ContactCTA from './components/ContactCTA';
import WorldReach from './components/WorldReach';
import StickyCTA from './components/StickyCTA';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <AboutBekaali />
        <BusinessDivisions />
        <IndustriesServed />
        <WhyChooseUs />
        <GlobalSourcing />
        <FeaturedProducts />
        <Testimonials />
        <LatestNews />
        <ContactCTA />
        <WorldReach />
      </main>
      <StickyCTA />
      <Footer />
    </>
  );
}